module.exports = __webpack_public_path__ + "static/media/S-WEB-Goal-9.d74c1700.png";